import { LifestyleSVG } from "@/components/we360/SVGIllustrations";
import { PillSelect } from "@/components/we360/PillSelect";
import { TextInput } from "@/components/we360/TextInput";
import { AlertBanner } from "@/components/we360/AlertBanner";

export default function Step5Lifestyle({ data, setField, errors, onBlur }) {
  const sleepVal = parseFloat(data.sueno);
  const showSleepWarning = !isNaN(sleepVal) && sleepVal < 7;

  return (
    <div>
      <div className="text-center mb-4">
        <LifestyleSVG tobacco={data.tabaco} alcohol={data.alcohol} sleep={data.sueno} />
      </div>

      {/* Sub-tarjeta 1: Hábitos de Consumo */}
      <div className="glass-card p-5 rounded-3xl mb-5 text-left border border-white/40 shadow-sm">
        <h3 className="text-xs font-bold uppercase tracking-wider text-[#00628F] mb-4">
          Hábitos de Consumo
        </h3>
        
        <PillSelect
          label="Consumo de tabaco"
          options={["No", "Sí", "Exfumador"]}
          value={data.tabaco === "Si" ? "Sí" : data.tabaco}
          onChange={(v) => setField("tabaco", v === "Sí" ? "Si" : v)}
          error={errors.getError("tabaco")}
          testId="pill-tabaco"
          columns={3}
        />

        <div className="mt-4">
          <PillSelect
            label="Consumo de alcohol"
            options={["Nunca", "Ocasional", "Frecuente (diario)"]}
            value={data.alcohol}
            onChange={(v) => setField("alcohol", v)}
            error={errors.getError("alcohol")}
            testId="pill-alcohol"
            columns={3}
          />
        </div>
      </div>

      {/* Sub-tarjeta 2: Calidad de Sueño */}
      <div className="glass-card p-5 rounded-3xl text-left border border-white/40 shadow-sm">
        <h3 className="text-xs font-bold uppercase tracking-wider text-[#00628F] mb-4">
          Descanso y Recuperación
        </h3>

        <TextInput
          label="Horas de sueño promedio"
          value={data.sueno}
          onChange={(v) => setField("sueno", v)}
          onBlur={() => onBlur("sueno")}
          placeholder="7"
          suffix="horas"
          type="number"
          min="0"
          max="24"
          step="0.5"
          error={errors.getError("sueno")}
          testId="input-sueno"
        />

        {showSleepWarning && (
          <div className="mt-4">
            <AlertBanner variant="warning" testId="alert-sueno">
              La OMS recomienda descansar entre 7 y 9 horas diarias para adultos.
            </AlertBanner>
          </div>
        )}
      </div>
    </div>
  );
}
